import React, { useContext, useEffect, type ComponentType } from 'react';
import { Route, ScrollToTop, Routes } from '@thd-olt-component-react/router';
import { AppContext } from '@thd-nucleus/app-render';
import { Error } from './pages';
import { getRoutes, type ServerPages } from './routes';
import type { LandingPageProps } from './pages/LandingPage';

/* The part of app-render's AppContext read here; the package ships no types. */
interface AppContextValue {
  instance: {
    router: {
      currentRouteName?: string;
      currentRouteComponent?: ComponentType<LandingPageProps>;
    };
  };
}

interface AppProps {
  serverPages?: ServerPages;
  customerAccountId?: string;
  userId?: string;
}
import './styles/app.scss';

export const App = ({ serverPages, customerAccountId, userId }: AppProps) => {
  const { instance } = useContext<AppContextValue>(AppContext);
  const { currentRouteName, currentRouteComponent } = instance.router;
  const routes = getRoutes(
    currentRouteName,
    currentRouteComponent,
    serverPages,
  );

  /* Undefined only on the server, which never renders App. */
  const LandingRoute = routes.landing.component!;

  useEffect(() => {
    document.title = 'The Home Depot';
  }, []);

  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route
          exact
          path={routes.landing.path}
          element={
            <LandingRoute
              customerAccountId={customerAccountId}
              userId={userId}
            />
          }
        />

        <Route path="/error" element={<Error />} />

        <Route element={<Error />} />
      </Routes>
    </>
  );
};
// App.whyDidYouRender = true;
